/* eslint-disable import/prefer-default-export */
import * as ReduxHelpers from '@src/utils/reduxHelpers'
import * as Filter from './filter.alerts.action.types'
const prefix = 'cam/alerts'

//Action Types

const GET_ALERTS_LIST_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_ALERTS_LIST_SUCCESS'
)
const GET_ALERT_DETAILS_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_ALERT_DETAILS_SUCCESS'
)
const GET_ALERTS_LIST_FAIL = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_ALERTS_LIST_FAIL'
)
const GET_ALERT_DETAILS_FAIL = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_ALERT_DETAILS_FAIL'
)
const DELETE_ALERT_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'DELETE_ALERT_SUCCESS'
)
const DELETE_ALERT_FAIL = ReduxHelpers.Types.createActionType(
  prefix,
  'DELETE_ALERT_FAIL'
)
const UPDATE_ALERT_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'UPDATE_ALERT_SUCCESS'
)
const UPDATE_ALERT_FAIL = ReduxHelpers.Types.createActionType(
  prefix,
  'UPDATE_ALERT_FAIL'
)
const REQUEST_PENDING = ReduxHelpers.Types.createActionType(
  prefix,
  'ALERT_REQUEST_PENDING'
)
const REQUEST_PENDING_WITH_GRAPH = ReduxHelpers.Types.createActionType(
  prefix,
  'REQUEST_PENDING_WITH_GRAPH'
)
const DISPOSE_ALERTS = ReduxHelpers.Types.createActionType(
  prefix,
  'DISPOSE_ALERTS'
)
const DISPOSE_ALERT = ReduxHelpers.Types.createActionType(
  prefix,
  'DISPOSE_ALERT'
)

export {
  GET_ALERTS_LIST_SUCCESS,
  Filter,
  DISPOSE_ALERT,
  DISPOSE_ALERTS,
  REQUEST_PENDING_WITH_GRAPH,
  REQUEST_PENDING,
  UPDATE_ALERT_FAIL,
  UPDATE_ALERT_SUCCESS,
  GET_ALERT_DETAILS_SUCCESS,
  DELETE_ALERT_FAIL,
  DELETE_ALERT_SUCCESS,
  GET_ALERT_DETAILS_FAIL,
  GET_ALERTS_LIST_FAIL
}
